import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { JsonLDService } from '../../services/json-ld.service';

export const jsonLDDeactivateGuard: CanActivateFn = () => {
  const jsonLDService = inject(JsonLDService);
  jsonLDService.remove('page');
  return true;
};
